import { FormFieldGroup, FormInput, FormLabel, FormLabelDescription, FormTextarea } from '$components'
import { Input } from './index'

export function EditClientDetailsContent() {
  return (
    <div className="flex flex-col gap-6 flex-grow">
      <FormFieldGroup>
        <FormLabel htmlFor={Input.Email}>
          Email
        </FormLabel>

        <FormInput
          name={Input.Email}
          type="email"
          placeholder="Enter client email..."
        />
      </FormFieldGroup>

      <FormFieldGroup>
        <FormLabel htmlFor={Input.Phone}>
          Phone Number
        </FormLabel>

        <FormInput
          name={Input.Phone}
          placeholder="Enter phone number..."
        />
      </FormFieldGroup>

      <FormFieldGroup>
        <FormLabel htmlFor={Input.InternalNotes}>
          Internal Notes
        </FormLabel>

        <FormLabelDescription>
          Add any internal notes about this client (only visible to you and your team).
        </FormLabelDescription>

        <FormTextarea
          name={Input.InternalNotes}
          placeholder="Enter any internal notes..."
        />
      </FormFieldGroup>
    </div>
  )
}
